// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"197":"72d9f668","639":"72d9f668"}[chunkId] + ".chunk.css";
};